class FullWidth {
    fullWidthChildren: NodeListOf<HTMLElement>;

    constructor() {
        this.init();
    }

    init() {
        this.fullWidthChildren = document.querySelectorAll(".full-section");
        if (this.fullWidthChildren != null) {

            if (this.fullWidthChildren.length > 0) {
                this.fullWidthChildren.forEach(el => {
                    const thisContainer = el.closest("section > div");
                    if (thisContainer != null) {
                        thisContainer.classList.remove("container-xxl");
                        thisContainer.classList.add("container-fluid", "p-0");
                    }
                })
            }
        }

    }
}

export default FullWidth;